import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../index';

interface ConfirmDeleteDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    itemName?: string;
    message?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    isLoading?: boolean;
}

export default function ConfirmDeleteDialog({
    open,
    onClose,
    onConfirm,
    title = "Confirmar exclusão",
    itemName,
    message,
    confirmButtonText = "Excluir",
    cancelButtonText = "Cancelar",
    isLoading = false
}: ConfirmDeleteDialogProps) {
    const getDefaultMessage = () => {
        if (message) return message;
        
        if (itemName) {
            return `Tem certeza que deseja excluir "${itemName}"?`;
        }
        
        return "Tem certeza que deseja excluir este item?";
    };

    return (
        <Dialog
            open={open}
            onClose={!isLoading ? onClose : undefined}
            aria-labelledby="confirm-delete-dialog-title"
            aria-describedby="confirm-delete-dialog-description"
        >
            <DialogTitle id="confirm-delete-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography id="confirm-delete-dialog-description">
                    {getDefaultMessage()}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Esta ação não pode ser desfeita.
                </Typography>
            </DialogContent>
            <DialogActions>
                <SecondaryButton 
                    onClick={onClose} 
                    variant="contained"
                    disabled={isLoading}
                >
                    {cancelButtonText}
                </SecondaryButton>
                <PrimaryButton
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    autoFocus
                    disabled={isLoading}
                >
                    {isLoading ? 'Excluindo...' : confirmButtonText}
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    );
}